<template>
  <div>
    <Title :pages="[{ icon: 'cog', page: page_title.toUpperCase() }]" />

    <v-container fluid>
      <v-row v-if="list_access">
        <v-col cols="12" md="4">
          <v-card class="mx-auto rounded-0 h-100">
              <v-subheader class="title-setting">Menu</v-subheader>

            <v-list v-model:selected="selectedItem" mandatory>

              <v-list-item v-for="(item, i) in items" :key="i" :value="i" color="primary">
                <template v-slot:prepend>
                  <font-awesome-icon :icon="item.icon" class="mr-2" />
                </template>

                <v-list-item-title class="text-body-1">
                  {{ item.text }}
                </v-list-item-title>
              </v-list-item>

            </v-list>
          </v-card>
        </v-col>

        <v-col cols="12" md="8" class="d-flex justify-center">
          <v-card class="mx-auto rounded-0 w-100">
            <MiEmpresa v-if="selectedItem.includes(0)" :mainItem="mainItem" @createItem="createItem"
              :loading="loading_submit" :loading_settings="loading" />
            <MisEtiquetas v-if="selectedItem.includes(1)" :mainItem="mainItem" @createItem="createItem"
              :loading="loading_submit" :loading_settings="loading" />
            <DescargarApp v-if="selectedItem.includes(2)" />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import GenericMixin from "@/mixins/GenericMixin.vue";
import SettingsMixin from "@/mixins/SettingsMixin.vue";
import { settingsService } from "@/libs/ws/settingsService";
import Title from "@/components/Title.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import MiEmpresa from "./MiEmpresa.vue";
import MisEtiquetas from "./MisEtiquetas.vue";
import DescargarApp from "./DescargarApp.vue";
import ValidMixin from "@/mixins/ValidMixin.vue";

export default {
  components: { Title, MiEmpresa, MisEtiquetas, DescargarApp },
  mixins: [GenericMixin, RolMixin, SettingsMixin, ValidMixin],
  data() {
    return {
      page_title: "Configuración",
      selectedItem: [0],
      service: settingsService,
      items: [
        { text: "Mi empresa", icon: "warehouse" },
        { text: "Etiquetas", icon: "print" },
        { text: "Descargar App", icon: "download" },
      ],
      mainItem: {
        id: 0,
        image_upload: null,
        logo_url: null,
        business_name: "",
        cuit: "",
        address: "",
        color_label: "", 
        image_label: null,
        logo_label_url: null
      },
      defaultItem: null,
      loading_submit: false
    };
  },
  mounted() {
    this.defaultItem = JSON.parse(JSON.stringify(this.mainItem));
    this.loadList(this.service);
  },
  methods: {
    loadList(service, param = null) {
      this.loading = true;
      if (param == null) {
        param = this.getFilterParams();
      }

      this.open_filter = false;
      service
        .filter(param)
        .then((response) => {
          // la bbdd es exclusiva de la empresa, por eso solo debe retornar un elemento.
          if(response.status) {
            if(response.result.list.length > 0) {
              this.mainItem = response.result.list[0];
              
            } 

          } else {
            this.toast.error(response.msg);
          }

          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    createItem(e, item, type) {
      // if (this.valid) {
      e.preventDefault();
      let formData = new FormData();
      if(type === 'company') {
        formData.append("id", item.id);
        if (item.image_upload) {
          formData.append("logo", item.image_upload);
        }
        formData.append("business_name", item.business_name);
        formData.append("cuit", item.cuit);
        
      } else if (type === 'labels') {
        formData.append("id", item.id);

        if (item.image_label) {
          formData.append("logo_label", item.image_label);
        }
  
        formData.append("color_label", item.color_label);
      }

      this.loading_submit = true;

      if (item.id > 0) {
        this.service
          .update(formData)
          .then((response) => {
            if (response.status) {
              this.toast.success("El " + this.page_title + " se modifico correctamente.");
              this.$store.commit('setLogo', response.result.logo_url);
              location.reload();
              this.$emit("loadList");
            } else {
              if (Object.prototype.hasOwnProperty.call(response, "message")) {
                this.toast.error(response.message);
              } else {
                this.toast.error(response.msg);
              }
            }
            this.loading_submit = false;
          })
          .catch((response) => {
            this.toast.error(response.msg);

          })
          .finally(() => {
            this.loading_submit = false;
          })

      } else {
        this.service
          .create(formData)
          .then((response) => {
            if (response.status) {
              this.toast.success("El " + this.page_title + " se creo correctamente.");
              localStorage.setItem("logo", response.result.logo_url);
              this.$store.commit('setLogo', localStorage.getItem("logo"));
              location.reload();
              this.$emit("loadList");
            } else {
              if (Object.prototype.hasOwnProperty.call(response, "message")) {
                this.toast.error(response.message);
              } else {
                this.toast.error(response.msg);
              }
            }
            this.loading_submit = false;
          })
          .catch((response) => {
            this.toast.error(response.msg);

          })
          .finally(() => {
            this.loading_submit = false;
          })
      }
      // } 

    },
  },
};
</script>
